import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

const Home = lazy(() => import('./home/home.component'));
const Activity = lazy(() => import('./activity/activity.component'));
const Content = lazy(() => import('./content/content.component'));
const SlotDetail = lazy(() => import('./content/slot-detail.component'));
const StockList = lazy(() => import('./stock/stock-list.component'));
const StockDetail = lazy(() => import('./stock/stock-detail.component'));
const TransactionDetail = lazy(() => import('./activity/transaction-detail.component'));

export function SpotsRoutes() {
    return (
        <Route path='spots'>
            <Route
                index
                element={<Navigate to='home' />}
            />
            <Route
                path='home'
                element={
                    <AsyncComponent>
                        <Home />
                    </AsyncComponent>
                }
            />
            <Route
                path='activities'
                element={
                    <AsyncComponent>
                        <Activity />
                    </AsyncComponent>
                }
            />
            <Route
                path='content'
                element={
                    <AsyncComponent>
                        <Content />
                    </AsyncComponent>
                }
            />
            <Route
                path='content/slots/:slotId'
                element={
                    <AsyncComponent>
                        <SlotDetail />
                    </AsyncComponent>
                }
            />
            <Route
                path='pudo/transactions/:transactionId'
                element={
                    <AsyncComponent>
                        <TransactionDetail />
                    </AsyncComponent>
                }
            />
            <Route
                path='items'
                element={<Navigate to='../content' />}
            />
            <Route path=':stockType'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <StockList />
                        </AsyncComponent>
                    }
                />
                <Route
                    path=':productId'
                    element={
                        <AsyncComponent>
                            <StockDetail />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
